import { render, staticRenderFns } from "./NotificationTaskSettingsRouterDialog.vue?vue&type=template&id=217c8ae4&"
import script from "./NotificationTaskSettingsRouterDialog.vue?vue&type=script&lang=js&"
export * from "./NotificationTaskSettingsRouterDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports